module.exports = __webpack_public_path__ + "static/credit-fair-0332095a7e008a2de5c2d4e99ed50bde.png";